export default {
  "home.heading.default": "wbijaj na calla",
  "home.heading.loading": "Otwieranie pokoju...",
  "home.heading.join": "wbijasz?",
  "home.heading.joined": "jesteś w środku",
  "home.heading.pending": "czekamy na hosta",
  "home.body.default": "stwórz pokój, rzuć linkiem, chilluj.",
  "home.body.loading": "sekunda, ogarniam pokój.",
  "home.body.join": "sprawdź kamerkę i mikrofon, i wbijaj.",
  "home.body.joined": "pokój odpalony. udostępnij link albo po prostu działaj.",
  "home.body.joined_in_room": "jesteś w pokoju — wbijaj albo udostępnij link.",
  "home.body.pending": "pokój jest zamknięty. host musi cię wpuścić.",
  "home.cta.create": "Stwórz pokój",
  "home.cta.join": "Dołącz do pokoju",
  "home.cta.enter": "Wejdź do pokoju",
  "home.cta.creating": "Tworzenie...",
  "home.cta.joining": "Dołączanie...",
  "home.cta.opening": "Otwieranie...",
  "home.cta.pending": "Czekam na wpuszczenie...",
  "home.copy_link": "skopiuj link",
  "home.copied": "skopiowane!",
  "home.leave": "wyjdź z pokoju",
  "home.back": "wróć",
  "home.no_participants": "pusto tu",
  "home.join_by_code": "dołącz przez kod",
  "home.code_placeholder": "wpisz kod",
  "home.name_placeholder": "twoje imię",
  "home.people_one": "osoba",
  "home.people_other": "osoby",
  "home.marketing.invite.title": "Stwórz pokój,\nwyślij link.",
  "home.marketing.invite.body": "Jedno kliknięcie i gotowe. Wyślij link znajomym i każdy może wbić — bez pobierania i zakładania konta.",
  "home.marketing.invite.preview_url": "yano.ai/POKOJ",
  "home.marketing.look.title": "Wyglądaj jak\nchcesz.",
  "home.marketing.look.body": "Kolorki, wygładzanie, winieta — albo całkowity blur na twarz. Twoja kamerka, twój vibe.",
  "home.marketing.host.title": "Twój pokój,\ntwoje zasady.",
  "home.marketing.host.body": "Zamknij pokój, wycisz kogoś albo go wyrzuć. Host ma pełną kontrolę.",
  "home.marketing.host.locked": "Pokój zamknięty",
  "home.marketing.host.waiting_to_join": "Czeka na wejście",
  "home.marketing.host.wants_to_join": "chce wbić",
  "home.marketing.anything.title": "Dosłownie do wszystkiego.",
  "home.marketing.anything.body": "Wspólna nauka, gierki, standupy z pracy, oglądanie filmów — albo po prostu chillowanie.",
  "home.marketing.use_case.study_group": "📚 wspólna nauka",
  "home.marketing.use_case.game_night": "🎮 gierki",
  "home.marketing.use_case.standup": "💼 standup",
  "home.marketing.use_case.watch_party": "🍿 wspólne oglądanie",
  "home.marketing.use_case.catch_up": "☕ ploteczki",
  "home.marketing.use_case.jam_session": "🎸 jam session",
  "home.marketing.use_case.book_club": "📖 klub książki",
  "home.marketing.use_case.coworking": "💻 co-working",
  "ended.heading": "call zakończony",
  "ended.left": "wyszedłeś z pokoju.",
  "ended.room_ended": "{title} się dla ciebie skończył.",
  "ended.rejoin": "wbij ponownie",
  "ended.rejoining": "łączę ponownie...",
  "ended.home": "wróć na główną",
  "call.connecting": "łączenie",
  "call.waiting": "czekamy na resztę",
  "call.invite_code": "kod zaproszenia",
  "call.audio_on": "dźwięk włączony",
  "call.muted": "wyciszony",
  "call.listening": "słucha",
  "call.audio_muted": "dźwięk wyciszony",
  "call.speaking": "mówi",
  "call.you": "ty",
  "call.you_label": "Ty",
  "call.you_suffix": "(ty)",
  "call.chat_placeholder": "napisz coś...",
  "call.guest": "gość",
  "call.room_fallback": "pokój",
  "call.focus_view": "Widok główny",
  "call.grid_view": "Siatka",
  "call.swap_main_video": "Zmień główne wideo",
  "call.open_chat": "Otwórz czat",
  "call.close_chat": "Zamknij czat",
  "call.leave_room": "Wyjdź z pokoju",
  "call.confirm_leave": "Wychodzisz?",
  "call.mic_on": "Mikrofon włączony",
  "call.muted_label": "Wyciszony",
  "call.camera_off": "Kamerka wyłączona",
  "call.connect_failed": "Błąd połączenia — sprawdź neta i spróbuj jeszcze raz.",
  "call.camera_access_failed": "Brak dostępu do kamerki. Sprawdź uprawnienia przeglądarki i spróbuj ponownie.",
  "call.recording_failed": "Nie udało się odpalić nagrywania. Call leci dalej bez niego.",
  "call.initialize_failed": "Coś poszło nie tak przy odpalaniu calla. Odśwież i spróbuj jeszcze raz.",
  "call.participants": "Uczestnicy",
  "call.open_participants": "Pokaż uczestników",
  "call.close_participants": "Ukryj uczestników",
  "call.lock_room": "Zamknij pokój",
  "call.unlock_room": "Otwórz pokój",
  "call.locked": "zamknięty",
  "call.unlocked": "otwarty",
  "call.kick_member": "Wyrzuć z pokoju",
  "call.mute_member": "Wycisz",
  "call.unmute_member": "Odcisz",
  "call.muted_by_host": "Wyciszony przez hosta",
  "call.waiting_to_join": "Czeka na wejście",
  "call.approve": "Wpuść",
  "call.deny": "Odrzuć",
  "call.profile_actions": "Akcje profilu",
  "call.profile_in_room": "W pokoju",
  "call.profile_role_host": "Host",
  "call.profile_role_you": "Ty",
  "call.profile_action_mute": "Wycisz dźwięk",
  "call.profile_action_mute_meta": "Tylko dla ciebie — nawet się nie dowiedzą",
  "call.profile_action_dm": "DM 1:1",
  "call.profile_action_dm_meta": "Zacznij prywatny czat na boku",
  "call.profile_action_view": "Zobacz pełny profil",
  "call.profile_action_view_meta": "Bio, języki, poprzednie sesje",
  "call.profile_action_report": "Zgłoś",
  "call.profile_action_report_meta": "Zgłoś do moderacji",
  "call.profile_sheet_close": "Zamknij akcje profilu",
  "call.profile_open_actions": "Otwórz akcje profilu",
  "call.dm_title": "Wiadomość prywatna",
  "call.dm_back": "Wróć do akcji",
  "call.dm_close": "Zamknij DM",
  "call.dm_status_online": "Online",
  "call.dm_in_room_with": "W tym pokoju",
  "call.dm_private_label": "Prywatny czat",
  "call.dm_private_meta": "Tylko wy we dwójkę widzicie te wiadomości",
  "call.dm_input_placeholder": "Napisz na priv…",
  "call.dm_send": "Wyślij",
  "call.dm_just_now": "teraz",
  "call.dm_seen_just_now": "Wyświetlono przed chwilą",
  "call.dm_typing": "{name} pisze…",
  "call.dm_minimize": "Minimalizuj",
  "call.dm_active_indicator": "Otwórz konwersację",
  "call.dm_unread_messages": "{count} nieprzeczytanych",
  "call.dm_toast_tap_to_open": "Kliknij, żeby otworzyć",
  "call.dm_reopen_aria": "Otwórz ponownie konwersację z {name}",
  "home.join_denied": "Host cię nie wpuścił.",
  "home.error.room_not_found": "Taki kod pokoju nie istnieje.",
  "home.error.profile_required": "Uzupełnij profil, żeby lecieć dalej.",
  "home.cta.set_up_profile": "Uzupełnij profil",
  "home.profile_trigger_new": "Kliknij, żeby dodać info o sobie",
  "home.profile_trigger_new_aria": "Uzupełnij profil",
  "home.profile_trigger_edit_aria": "Edytuj profil",
  "profile.eyebrow_new": "przywitaj się",
  "profile.eyebrow_edit": "twój profil",
  "profile.title_new": "Zrób to po swojemu.",
  "profile.title_edit": "Edytuj profil",
  "profile.subtitle": "Kilka szybkich info, żeby inni wiedzieli, z kim gadają.",
  "profile.add_photo": "Dodaj fotkę",
  "profile.add_photo_soon": "fotki wkrótce",
  "profile.photo_empty": "kliknij, żeby dodać fotkę",
  "profile.photo_ready": "fotka gotowa",
  "profile.photo_save_first": "zapisz profil, zanim wrzucisz fotkę",
  "profile.photo_crop_caption": "wykadruj fotkę",
  "profile.photo_auto_caption": "przesuń i przybliż, a my zapiszemy to automatycznie",
  "profile.photo_upload": "Wgraj fotkę",
  "profile.photo_replace": "Zmień fotkę",
  "profile.photo_remove": "Usuń fotkę",
  "profile.photo_cancel": "Anuluj",
  "profile.photo_save": "Zapisz fotkę",
  "profile.photo_uploading": "Wgrywanie fotki…",
  "profile.photo_removing": "Usuwanie fotki…",
  "profile.photo_choose_another": "Wybierz inną",
  "profile.photo_drag_hint": "Przeciągnij fotkę do kółka. Zmiany zapisują się same.",
  "profile.photo_zoom": "Przybliż",
  "profile.photo_horizontal": "Kadr w poziomie",
  "profile.photo_vertical": "Kadr w pionie",
  "profile.name_label": "Imię",
  "profile.name_placeholder": "Jak mamy cię nazywać?",
  "profile.gender_label": "Jestem",
  "profile.gender.woman": "Kobietą",
  "profile.gender.man": "Mężczyzną",
  "profile.gender.unspecified": "Wolę nie mówić",
  "profile.bio_label": "Bio",
  "profile.bio_optional": "opcjonalnie",
  "profile.bio_placeholder": "Języki, którymi gadasz, co lubisz, cokolwiek…",
  "profile.cta_new": "Lecimy",
  "profile.cta_edit": "Zapisz zmiany",
  "profile.saving": "Zapisywanie…",
  "profile.close": "Zamknij",
  "profile.error.save_failed": "Nie udało się zapisać profilu. Spróbuj jeszcze raz.",
  "profile.error.avatar_invalid_type": "Wybierz obrazek w formacie PNG, JPEG, GIF lub WebP.",
  "profile.error.avatar_too_large": "Wybierz plik mniejszy niż 5 MB.",
  "profile.error.avatar_too_small": "Wybierz obrazek, który ma co najmniej 96x96 pikseli.",
  "profile.error.avatar_load_failed": "Nie mogliśmy wczytać tego obrazka. Spróbuj z innym plikiem.",
  "profile.error.avatar_failed": "Nie udało się wgrać fotki. Spróbuj ponownie.",
  "profile.error.avatar_remove_failed": "Nie udało się usunąć fotki. Spróbuj ponownie.",
  "effects.title": "Efekty",
  "effects.soft": "Miękki focus",
  "effects.vignette": "Winieta",
  "effects.face": "Blur twarzy",
  "effects.face_preview_only": "Blur twarzy (tylko podgląd)",
  "effects.face_viewer_side": "Blur twarzy (u widza)",
  "effects.face_strength": "Moc blura",
  "effects.grade.off": "WYŁ",
  "effects.grade.pop": "POP",
  "effects.grade.warm": "CIEPŁY",
  "effects.grade.cool": "ZIMNY",
  "effects.grade.bw": "CZ-B",
  "camera.off": "kamerka wyłączona",
  "camera.check": "sprawdź kamerkę",
  "camera.retry": "spróbuj ponownie",
  "camera.ready": "kamerka gotowa",
  "camera.idle.title": "Odpal kamerkę",
  "camera.idle.hint": "Poprosimy przeglądarkę o dostęp, kiedy będziesz gotowy.",
  "camera.idle.button": "Włącz kamerkę",
  "camera.status.idle": "Czekamy na ciebie",
  "camera.status.off": "Kamerka jest wyłączona",
  "camera.status.loading": "Prośba o dostęp do kamerki...",
  "camera.status.denied": "Zezwól na dostęp do kamerki w przeglądarce i spróbuj ponownie.",
  "camera.status.error": "Podgląd z kamerki padł. Spróbuj jeszcze raz.",
  "camera.status.unsupported": "Ta przeglądarka nie obsługuje dostępu do kamerki.",
  "camera.status.insecure": "Dostęp do kamerki wymaga HTTPS lub localhosta.",
  "camera.status.attach_failed": "Nie udało się odpalić podglądu z kamerki. Spróbuj ponownie.",
  "camera.guest_name_placeholder": "Imię gościa",
  "camera.flip": "Obróć kamerkę",
  "camera.save_name": "Zapisz",
  "camera.edit_name": "Edytuj imię",
  "mic.on": "Wyłącz mikrofon",
  "mic.off": "Włącz mikrofon",
  "video.on": "Wyłącz kamerkę",
  "video.off": "Włącz kamerkę",
  "chat.title": "czat",
  "chat.close": "Zamknij czat",
  "chat.loading": "ładowanie...",
  "chat.load_earlier": "załaduj starsze",
  "chat.empty": "tu jeszcze nic nie ma",
  "chat.send_error": "Wiadomość nie poszła — spróbuj jeszcze raz.",
  "chat.input_placeholder": "napisz coś...",
  "room.host": "Host",
  "app.room_default_title": "Stwórz pokój",
  "app.chat_connection_rejected": "Czat nie mógł się połączyć — spróbuj odświeżyć.",
  "app.copy_failed": "Nie udało się skopiować linku. Zaznacz i skopiuj go ręcznie.",
  "app.chat_not_connected": "Czat nie jest jeszcze połączony. Daj mu chwilę i spróbuj ponownie.",
  "footer.terms": "Regulamin",
  "footer.copyright": "© 2026 Yano.AI"
}
